export const Roles = {
  Admin: 'Admin',
  OrgAdmin: 'OrgAdmin',
  Student: 'Student',
  Professor: 'Professor',
}
